export default "__VITE_ASSET__BWhCewWY__"